import styled from 'styled-components';
import mainColors from '../../main-colors';

const LabelWrapper = styled.label`
  /* max-width: 210px; */
  display: block;
  position: relative;
  margin: 0 8px;

  .label-text {
    text-align: center;
  }

  .error-message {
    color: ${mainColors.error_color};
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    margin-top: 2px;
  }
`;

export default LabelWrapper;
